var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tooltip',{attrs:{"placement":"top","trigger":'hover'}},[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('span',[_vm._v(_vm._s(_vm.value))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }